
export function useStringManipulation() {

  function capitaliseFirstLetter(value:string) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  
  return { capitaliseFirstLetter }
}